import { scoreToRating } from "./scoreGrade";

function rawSignalValue(value) {
  if (value == null || value === "") return "Not established";
  if (typeof value === "object") {
    if (value.text != null && value.text !== "") return String(value.text);
    if (value.score != null) return scoreToRating(value.score, { fallback: "Not established" });
    if (value.value != null) return scoreToRating(value.value, { fallback: "Not established" });
  }
  if (typeof value === "number") return scoreToRating(value, { fallback: "Not established" });
  return String(value);
}

export function normalizedSignalValue(value) {
  const raw = rawSignalValue(value)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase();
  const scoreGrade = /^\s*\d+\s*[+\-]\s*$/.test(raw);
  return raw
    .replace(scoreGrade ? /[^a-z0-9+\-]+/g : /[^a-z0-9]+/g, " ")
    .trim();
}

function relationshipUpdateDefinitions(update) {
  const changes = update?.changes?.signal_changes || {};
  return [
    ["Stance", changes.attitude],
    ["Trust", changes.trust],
    ["Buying intent", changes.buying_intent],
    ["Churn risk", changes.churn_risk || changes.risk_of_churn],
    ["Tone", changes.emotional_tone],
  ];
}

// The compact Relationship Update shows every relationship dimension supplied
// by the backend, not only dimensions whose rounded display text changed.
export function relationshipUpdateSignals(update) {
  return relationshipUpdateDefinitions(update).filter(([, signal]) => (
    signal && (signal.from != null || signal.to != null)
  ));
}

// Retained for callers/tests that explicitly need materially changed signals.
export function changedRelationshipSignals(update) {
  return relationshipUpdateSignals(update).filter(([, signal]) => (
    normalizedSignalValue(signal.from) !== normalizedSignalValue(signal.to)
  ));
}

function findingValue(value) {
  if (value?.finding) return value.finding;
  if (value && typeof value === "object") {
    if (value.text != null || value.score != null || value.value != null) return value;
    return null;
  }
  return value;
}

export function relationshipBaseline(analysis) {
  const deep = analysis?.deep_dive || {};
  const definitions = [
    ["Stance", findingValue(deep.stance)],
    ["Trust", analysis?.trust_level],
    ["Buying intent", analysis?.buying_intent],
    ["Churn risk", analysis?.risk_of_churn],
    ["Tone", findingValue(deep.tone) || deep.interaction_tone || analysis?.customer_mood],
  ];
  return definitions.filter(([, value]) => (
    value != null
    && value !== ""
    && normalizedSignalValue(value) !== "not established"
  ));
}
